import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Chip,
  List,
  Menu,
  MenuItem,
  Paper,
  RaisedButton,
  Checkbox,
  TextField,
  DatePicker,
  SelectField,
  AutoComplete,
  CircularProgress
} from 'material-ui'
import FlatButton from 'material-ui/FlatButton'
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import moment from 'moment'

import Header from '../../components/Header/Header'
import EntityTable from '../../components/EntityTable/EntityTable'
import {
  getCities,
  getRAM,
  getAgents,
  getOrderList
} from '../../actions/search'
import TypeAhead from '../../components/TypeAhead/TypeAhead'
import Constants from '../../utils/CommonConstants'
import { instance } from '../../lib/api'
import { debounce } from '../../lib/helper'

if (process.env.WEBPACK) {
  require('./Search.css')
}

const styles = {
  datepicker: {
    marginRight: '25px'
  },
  status: {
    backgroundColor: '#dcdcdc'
  }
}

const mapStateToProps = state => ({
  userInfo: state.userInfo,
  agents: state.agents,
  cities: state.cities,
  citiesIdNameMap: state.citiesIdNameMap,
  caseStatusMap: state.caseStatusMap,
  data: state.searchData
})

const mapDispatchToProps = dispatch => {
  return {
    getCities: bindActionCreators(getCities, dispatch),
    getAgents: bindActionCreators(getAgents, dispatch),
    getOrderList: bindActionCreators(getOrderList, dispatch),
    getRAM: bindActionCreators(getRAM, dispatch),
    dispatch
  }
}
const defaultOrderType = Constants.orderTypes[0]
class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openDialog: false,
      isFetching: false,
      gotResult: false,
      orderTypes: Constants.orderTypes,
      orderType: defaultOrderType,
      paymentKey: Constants.paymentSearchKeysObj.paymentsId,
      fields: Constants.entityTableFields[defaultOrderType.caseSubType],
      orderIds: [],
      orderIdsString: '',
      dataList: {},
      cities: [],
      shouldHide: true,
      selectedCities: [],
      thisCity: '',
      agents: [],
      selectedAgents: [],
      thisAgent: '',
      rams: [],
      selectedRams: {},
      createdAt: {
        start: null,
        end: null
      },
      updatedAt: {
        start: null,
        end: null
      },
      status: Constants.orderTypeStatusMap[defaultOrderType.caseSubType],
      selectedStatus: {},
      searchClicked: false
    }
    this.styles = {
      chip: {
        margin: 4
      },
      wrapper: {
        display: 'flex',
        flexWrap: 'wrap'
      },
      checkbox: {
        marginRight: 3,
        float: 'left',
        width: '24.5%'
      },
      buttondiv: {
        margin: '20px auto',
        width: '150px'
      },
      status: {
        width: '100%'
      },
      paper: {
        //width: '40%',
        //display: 'inline-block',
      },
      bigpaper: {
        width: '95%',
        display: 'block',
        margin: '2px auto',
        padding: '15px'
      }
    }
    this.getRAM = debounce(props.getRAM, 500)
  }

  getCities = () => {
    const { citiesIdNameMap, getCities } = this.props
    if (!(citiesIdNameMap && Object.keys(citiesIdNameMap).length)) {
      getCities()
    }
  }

  getAgents = () => {
    if (this.props.agents && this.props.agents.length !== 0) {
      return
    }
    this.props.getAgents()
  }

  componentDidMount() {
    this.getCities()
    this.getAgents()
  }

  processResultSet(results = []) {
    const { caseStatusMap, citiesIdNameMap = {} } = this.props
    return results.map(item => {
      item.rcmOrder.status = caseStatusMap[item.rcmOrder.statusId]
      item.rcmOrder.cityName = citiesIdNameMap[item.rcmOrder.cityId]
      item.rcmOrder.createdAtDate = moment(item.rcmOrder.createdAt).format(
        Constants.DATE_FORMAT
      )
      return item
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data !== this.props.data) {
      let dataArr = this.state.dataArr || []
      const totalCount = nextProps.data && nextProps.data.totalCount
      let start = 0
      if (
        nextProps.data &&
        nextProps.data.results &&
        dataArr.length < totalCount
      ) {
        const resultSet = this.processResultSet(nextProps.data.results)
        if (this.state.start > 0) {
          dataArr = dataArr.concat(resultSet)
        } else {
          dataArr = resultSet
        }
        start = dataArr.length
      }
      const dataList = {
        start,
        isFetching: false,
        gotResult: true,
        totalCount,
        dataArr
      }
      dataList.dataArr = dataList.dataArr.map(item => {
        item.rcmOrder.status = nextProps.caseStatusMap[item.rcmOrder.statusId]
        return item
      })
      this.setState(dataList)
    }
    if (nextProps.getRAM !== this.props.getRAM) {
      this.getRAM = debounce(nextProps.getRAM, 500)
    }
  }

  refreshTable = () => {
    this.setState(
      {
        start: 0,
        dataArr: [],
        rows: this.state.dataArr.length
      },
      this.getResult
    )
  }

  getResultForSearch = () => {
    this.setState(
      {
        searchClicked: true,
        thisCity: '',
        thisAgent: '',
        start: 0,
        dataArr: []
      },
      this.getResult
    )
  }

  getResult = () => {
    this.setState({
      searchClicked: false,
      isFetching: true
    })
    this.props.getOrderList(this.state)
  }

  handleUpdateCity = value => {
    this.setState({
      thisCity: value
    })
    if (this.props.cities[value]) {
      const selectedCities = this.state.selectedCities
      selectedCities[value] = this.props.cities[value]
      this.setState({
        selectedCities,
        thisCity: '',
        gotResult: false
      })
    }
  }

  handleUpdateAgent = value => {
    this.setState({
      thisAgent: value
    })
    if (this.props.agents[value]) {
      const selectedAgents = this.state.selectedAgents
      selectedAgents[value] = this.props.agents[value]
      this.setState({
        selectedAgents,
        thisAgent: '',
        gotResult: false
      })
    }
  }

  handleRequestDelete = (key, type) => {
    if (type === 'city') {
      const selectedCities = this.state.selectedCities
      delete selectedCities[key]
      this.setState({
        selectedCities,
        gotResult: false
      })
    } else if (type === 'status') {
      const selectedStatus = this.state.selectedStatus
      delete selectedStatus[key]
      this.setState({
        selectedStatus,
        gotResult: false
      })
    } else if (type === 'ram') {
      const selectedRams = this.state.selectedRams
      delete selectedRams[key]
      this.setState({
        selectedRams,
        gotResult: false
      })
    } else if (type === 'agent') {
      const selectedAgents = this.state.selectedAgents
      delete selectedAgents[key]
      this.setState({
        selectedAgents,
        gotResult: false
      })
    }
  }

  statusAddDelete = (status, event, isChecked) => {
    const selectedStatus = this.state.selectedStatus
    if (isChecked) {
      selectedStatus[status] = true
    } else {
      delete selectedStatus[status]
    }
    this.setState({
      selectedStatus,
      gotResult: false
    })
  }

  ramUpdate = rcm => {
    const selectedRams = this.state.selectedRams
    selectedRams[rcm.email] = rcm
    this.setState({
      selectedRams,
      gotResult: false
    })
  }

  renderStatus = status => {
    return (
      <Checkbox
        key={status}
        label={this.props.caseStatusMap[status]}
        style={this.styles.checkbox}
        checked={this.state.selectedStatus[status] || false}
        onCheck={this.statusAddDelete.bind(this, status)}
        labelStyle={{ color: '#d3d3d3' }}
      />
    )
  }

  renderChipCity = name => {
    return this.renderChip(name, 'city')
  }

  renderChipRAM = name => {
    return this.renderChip(name, 'ram')
  }

  renderChipAgents = name => {
    return this.renderChip(name, 'agent')
  }

  renderChip = (name, type) => {
    const displayName = type === 'ram' ? name.split('@')[0] : name
    return (
      <Chip
        key={name}
        onRequestDelete={() => this.handleRequestDelete(name, type)}
        style={this.styles.chip}
      >
        {displayName}
      </Chip>
    )
  }

  updateDateFilters = (type, startEnd, date) => {
    const thisDate =
      type === 'created' ? this.state.createdAt : this.state.updatedAt
    if (startEnd === 'start') {
      thisDate.start = moment(date).startOf('day').toDate()
    } else {
      thisDate.end = moment(date).endOf('day').toDate()
    }
    if (type === 'created') {
      this.setState({
        createdAt: thisDate,
        gotResult: false
      })
    } else {
      this.setState({
        updatedAt: thisDate,
        gotResult: false
      })
    }
  }

  handleOrderTypeChange = (event, index, value) => {
    if (this.state.orderType !== value) {
      this.setState({
        orderType: value,
        selectedStatus: {},
        orderIds: [],
        orderIdsString: '',
        fields: Constants.entityTableFields[value.caseSubType],
        status: Constants.orderTypeStatusMap[value.caseSubType],
        gotResult: false
      })
    }
  }

  handlePaymentKeyChange = (event, index, value) => {
    if (this.state.paymentKey !== value) {
      this.setState({
        orderIds: [],
        orderIdsString: '',
        paymentKey: value
      })
    }
  }

  handleChangeCreatedStart = (event, date) => {
    this.updateDateFilters('created', 'start', date)
  }
  handleChangeCreatedEnd = (event, date) => {
    this.updateDateFilters('created', 'end', date)
  }
  handleChangeLastModifiedStart = (event, date) => {
    this.updateDateFilters('lastModified', 'start', date)
  }
  handleChangeLastModifiedEnd = (event, date) => {
    this.updateDateFilters('lastModified', 'end', date)
  }

  loadMore = () => {
    this.getResult()
  }

  addOrderIds = (event, value) => {
    const ids = value.split(',')
    const orderIdsString = value
    const orderIds = []
    const { orderType, paymentKey } = this.state
    if (
      [
        Constants.CaseSubTypeMap.BROKER.TERMSHEET,
        Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET,
        Constants.CaseSubTypeMap.MAKAAN.TERMSHEET
      ].includes(orderType.caseSubTypeId)
    ) {
      ids.forEach(token => {
        token = token.trim()
        if (token) {
          orderIds.push(token)
        }
      })
    } else {
      ids.forEach(id => {
        const numId = parseInt(id)
        if (numId == id) {
          //  don't make it triple equal to
          orderIds.push(numId)
        }
      })
    }
    this.setState({
      orderIds,
      gotResult: false,
      orderIdsString
    })
  }

  getOrderIdsLabelText = () => {
    let label
    switch (this.state.orderType.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER.PAYMENTS:
      case Constants.CaseSubTypeMap.MAKAAN.PAYMENTS:
      case Constants.CaseSubTypeMap.OWNER.PAYMENTS:
        label = 'Payments Id'
        break
      case Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS:
        label =
          this.state.paymentKey === Constants.paymentSearchKeysObj.salesForceId
            ? 'Salesforce Id'
            : 'Payments Id'
        break
      case Constants.CaseSubTypeMap.DEVELOPER.TERMSHEET:
      case Constants.CaseSubTypeMap.BROKER.TERMSHEET:
      case Constants.CaseSubTypeMap.MAKAAN.TERMSHEET:
        label = 'Termsheet Number'
        break
      default:
        label = 'Order Id'
        break
    }
    return label
  }

  render() {
    const agents = this.props.agents || {}
    const cities = this.props.cities || {}
    const { userInfo: { roles = [] } = {} } = this.props
    const {
      roles: { rcmDataAssignment }
    } = Constants
    const isRcmDataAssignment = roles.includes(rcmDataAssignment)
    const minDateCreatedAt =
      this.state.createdAt.start || Constants.minDateAllowed
    const maxDateCreatedAt =
      this.state.createdAt.end || Constants.maxDateAllowed

    const minDateUpdatedAt =
      this.state.updatedAt.start || Constants.minDateAllowed
    const maxDateUpdatedAt =
      this.state.updatedAt.end || Constants.maxDateAllowed
    const csvIdsLabel = this.getOrderIdsLabelText()

    return (
      <div>
        <Header {...this.props} />
        <div className='search-page'>
          <Paper style={this.styles.bigpaper}>
            <div className='frow'>
              <span className='tcol'>
                <List style={this.styles.paper}>
                  <AutoComplete
                    hintText='City name'
                    filter={AutoComplete.caseInsensitiveFilter}
                    dataSource={Object.keys(cities)}
                    onUpdateInput={this.handleUpdateCity}
                    maxSearchResults={10}
                    searchText={this.state.thisCity}
                  />
                  <div style={this.styles.wrapper}>
                    {Object.keys(this.state.selectedCities).map(
                      this.renderChipCity,
                      this
                    )}
                  </div>
                </List>
              </span>
              <span className='tcol ta-c'>
                <List style={this.styles.paper}>
                  <TypeAhead
                    onChange={this.ramUpdate}
                    hintText='R A M'
                    getDataFunction={this.getRAM}
                    clearText={this.state.searchClicked}
                  />
                  <div style={this.styles.wrapper}>
                    {Object.keys(this.state.selectedRams).map(
                      this.renderChipRAM,
                      this
                    )}
                  </div>
                </List>
              </span>
              <span className='tcol ta-r'>
                <List>
                  {agents && (
                    <AutoComplete
                      hintText='Agent name'
                      filter={AutoComplete.caseInsensitiveFilter}
                      dataSource={Object.keys(agents)}
                      onUpdateInput={this.handleUpdateAgent}
                      maxSearchResults={10}
                      searchText={this.state.thisAgent}
                    />
                  )}
                  <div style={this.styles.wrapper}>
                    {Object.keys(this.state.selectedAgents).map(
                      this.renderChipAgents,
                      this
                    )}
                  </div>
                </List>
              </span>
            </div>

            <div className='frow'>
              <div className='lcol'>
                <div className='date-wrap'>
                  <DatePicker
                    floatingLabelText='Created Start Date'
                    onChange={this.handleChangeCreatedStart}
                    value={this.state.createdAt.start}
                    maxDate={maxDateCreatedAt}
                    style={styles.datepicker}
                  />
                  <DatePicker
                    floatingLabelText='Created End Date'
                    onChange={this.handleChangeCreatedEnd}
                    value={this.state.createdAt.end}
                    minDate={minDateCreatedAt}
                    style={styles.datepicker}
                  />
                </div>
              </div>
              <div className='rcol'>
                <div className='date-wrap'>
                  <DatePicker
                    floatingLabelText='Last Modified Start Date'
                    onChange={this.handleChangeLastModifiedStart}
                    value={this.state.updatedAt.start}
                    maxDate={maxDateUpdatedAt}
                    style={styles.datepicker}
                  />
                  <DatePicker
                    floatingLabelText='Last Modified End Date'
                    onChange={this.handleChangeLastModifiedEnd}
                    value={this.state.updatedAt.end}
                    minDate={minDateUpdatedAt}
                    style={styles.datepicker}
                  />
                </div>
              </div>
            </div>

            <div className='frow'>
              <List style={this.styles.status}>
                {this.state.status.map(this.renderStatus, this)}
              </List>
            </div>

            <div className='container-fluid'>
              <div className='col-xs-6 col-md-4 col-lg-3'>
                <SelectField
                  floatingLabelText='OrderType'
                  value={this.state.orderType}
                  onChange={this.handleOrderTypeChange}
                >
                  {this.state.orderTypes.map(type => (
                    <MenuItem
                      key={type.label}
                      value={type}
                      primaryText={type.label}
                    />
                  ))}
                </SelectField>
              </div>
              {this.state.orderType.caseSubTypeId ===
                Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS && (
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <SelectField
                    floatingLabelText='Payment Key'
                    value={this.state.paymentKey}
                    onChange={this.handlePaymentKeyChange}
                  >
                    {Constants.paymentSearchKeys.map(item => (
                      <MenuItem
                        key={item.key}
                        value={item.key}
                        primaryText={item.label}
                      />
                    ))}
                  </SelectField>
                </div>
              )}
              <div className='col-xs-6 col-md-4 col-lg-3'>
                <TextField
                  name={csvIdsLabel}
                  hintText='Enter comma seperated ids'
                  floatingLabelText={csvIdsLabel}
                  value={this.state.orderIdsString}
                  onChange={this.addOrderIds}
                />
              </div>
            </div>
          </Paper>

          <div style={this.styles.buttondiv}>
            <RaisedButton
              label='Search Result'
              primary
              onClick={this.getResultForSearch}
            />
            {this.state.isFetching &&
              (!this.state.dataArr || this.state.dataArr.length === 0) && (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                  <CircularProgress thickness={5} />
                </div>
              )}
          </div>
          {this.state.isFetching && <span>Fetching.....</span>}
          {this.state.gotResult && (
            <div>
              {this.state.dataArr.length > 0 ? (
                <EntityTable
                  fields={this.state.fields}
                  dataArr={this.state.dataArr}
                  totalCount={this.state.totalCount}
                  loadMore={this.loadMore}
                  location={this.props.location}
                  isFetching={this.state.isFetching}
                  filters={this.state}
                  refreshTable={this.refreshTable}
                  caseSubTypeId={this.state.orderType.caseSubTypeId}
                  showMassAssign={isRcmDataAssignment}
                />
              ) : (
                <div>
                  {!this.state.isFetching && (
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      Nothing to show yet!
                      <br />
                      Please try modifying some filters.
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

Search.propTypes = {
  location: PropTypes.object,
  agents: PropTypes.object,
  getRAM: PropTypes.func,
  getCities: PropTypes.func,
  getAgents: PropTypes.func,
  getOrderList: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)



/** WEBPACK FOOTER **
 ** ./src/containers/Search/Search.js
 **/